import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Checkbox } from "../../../../components/checkbox";
import { MANDATORY_SURVEY, OPTIONAL_SURVEY } from "../../../../constants/surveyTypes";
import { updatePerson } from "../../../../api/secureApi";
import { adjustState } from "./utils";
import { handleError } from "../../../../utils/handleError";

export function WhyRecordClearing() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [currentValues, setCurrentValues] = useState([]);
  const [clearingReasonsError, setClearingReasonsError] = useState(false);
  const [genericErrorMessage, setGenericErrorMessage] = useState("");
  const { register, handleSubmit } = useForm({ mode: "all" });

  const onSubmit = (data) => {
    if (currentValues.length === 0) {
      setClearingReasonsError(true);
    } else {
      const currentMandatorySurvey = state.surveys.find(
        (survey) => survey.type === MANDATORY_SURVEY,
      );
      let currentOptionalSurvey = state.surveys.find((survey) => survey.type === OPTIONAL_SURVEY);
      if (currentOptionalSurvey) {
        currentOptionalSurvey.answers.clearing_reasons = [...currentValues];
        currentOptionalSurvey.answers.clearing_reasons_other = data.clearing_reasons_other;
      } else {
        currentOptionalSurvey = {
          type: OPTIONAL_SURVEY,
          answers: {
            clearing_reasons: [...currentValues],
            clearing_reasons_other: data.clearing_reasons_other,
          },
        };
      }
      const stateToSubmit = {
        profile_id: state.profile_id,
        surveys: [currentOptionalSurvey, currentMandatorySurvey],
      };
      adjustState(state, stateToSubmit);
      // eslint-disable-next-line no-console
      console.log("stateToSubmit in clearing_reasons", stateToSubmit);

      updatePerson(stateToSubmit)
        .then((response) => {
          // eslint-disable-next-line no-console
          console.log("response in clearing_reasons", response);
          navigate("/register/interested-info", { state: response });
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log("error in clearing_reasons", error);
          handleError(error, setGenericErrorMessage, navigate);
        });
    }
  };

  return (
    <>
      <section id="heading">
        <div className="container mx-auto mt-10 flex max-w-3xl flex-col px-4">
          <h2 className="font-serif text-xl">
            9. Why are you seeking to clear your record now? (please select all that apply)
          </h2>
        </div>
      </section>
      <section id="form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="container mx-auto my-10 flex max-w-3xl flex-col overflow-y-scroll px-4">
            <div className="relative mb-4 mt-2 rounded-md shadow-sm">
              <Checkbox
                value="to be able to volunteer at my children's school"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to eliminate the stigma associated with a record"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to get a college education"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to get a new job"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to get a professional license"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to get a promotion"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to improve ability to rent a house or apartment"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to increase self-confidence"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to obtain life insurance"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to restore my gun rights"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to travel freely"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="to vote"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="for religious reasons"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              <Checkbox
                value="other (please specify below)"
                currentValues={currentValues}
                setCurrentValues={setCurrentValues}
              />
              {clearingReasonsError && (
                <p className="mt-2 text-sm text-red-600" id="employed-error">
                  Answer is required.
                </p>
              )}
            </div>
            <div className="relative mb-4 mt-2 rounded-md shadow-sm">
              <input
                type="text"
                name="clearing_reasons_other"
                id="clearing_reasons_other"
                className="block w-full rounded-md border-0 py-4 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-500
              placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-500 sm:text-sm sm:leading-6"
                placeholder="other"
                defaultValue=""
                aria-invalid="false"
                aria-describedby="clearing_reasons_other-error"
                {...register("clearing_reasons_other")}
              />
              {/*<Error errors={errors} name="clearing_reasons_other" />*/}
            </div>
            <div className="flex flex-col justify-center">
              {genericErrorMessage && (
                <div className="mb-2  text-center text-sm text-red-600" id="email-error">
                  {genericErrorMessage}
                </div>
              )}
              <button
                type="submit"
                className="mb-6 w-full rounded-full bg-rasapink px-24 py-4 font-bold text-white hover:shadow-xl"
              >
                next
              </button>
            </div>
          </div>
        </form>
      </section>
    </>
  );
}
